import type {RecipientComposition} from "../../shared/recipients";

/** Unfinished send edits only: never persisted to a database or browser storage. */
export interface SendRecipientDraft {clientId:string|null;composition:RecipientComposition;toQuery:string;ccQuery:string;senderCopyEmail:string|null}
export interface SendCopyDraft {subject?:string;message?:string;recipients?:SendRecipientDraft}
let identity: string | null = null;
const copies = new Map<string,SendCopyDraft>();
export function readSendCopy(scope:string|null,key:string):SendCopyDraft {
  if(identity!==scope){copies.clear();identity=scope;}
  return scope ? structuredClone(copies.get(key) ?? {}) : {};
}
export function writeSendCopy<K extends keyof SendCopyDraft>(scope:string|null,key:string,field:K,value:SendCopyDraft[K]):void {
  if(!scope || identity!==scope)return;
  if(!copies.has(key) && copies.size>=32)copies.delete(copies.keys().next().value!);
  copies.set(key,{...copies.get(key),[field]:structuredClone(value)});
}
export function clearSendCopy(scope:string|null,key:string):void {if(scope&&identity===scope)copies.delete(key);}
export function moveSendCopy(scope:string|null,from:string,to:string):void {
  if(scope&&identity===scope&&copies.has(from)){copies.set(to,{...copies.get(from),...copies.get(to)});copies.delete(from);}
}
